@if (showFilter) {
  <div class="tks-filters-chip-container">
    <div class="tks-filter-title">
      <h4 class="ark-h4 mt-3">
        {{ 'multimedia.OptionsFilter' | translate }}
      </h4>
    </div>
    <div class="tks-chips-wrapper">
      <div>
        <mat-chip-listbox class="w-100" aria-label="Selection by chip">
          @for (chipFilter of getCustomChipFilters; track chipFilter.Id) {
            <mat-chip-option
              class="ark-chips-custom"
              [ngClass]="returnClass(chipFilter)"
              (click)="selectFilterChip(chipFilter.Id)"
              (keydown.enter)="selectFilterChip(chipFilter.Id)"
              >
              <div
                class="ark-container-chip"
              [ngClass]="{
                selected: filterSelected === chipFilter.Id,
                'not-selected': filterSelected !== chipFilter.Id
              }"
                >
                @if (chipFilter.Icon) {
                  <i [class]="chipFilter.Icon"></i>
                }
                <span>{{ chipFilter.Title | translate }}</span>
                @if (filterSelected === chipFilter.Id) {
                  <i
                    class="fas fa-times-circle"
                    (click)="$event.stopPropagation(); onClearFilter()"
                    (keydown.enter)="$event.stopPropagation(); onClearFilter()"
                  ></i>
                }
              </div>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      <div class="tks-filter-buttons">
        <a class="btn ark-btn-action close" (click)="onHiddenFilter()">
          <span><i class="fal fa-times"></i></span>
        </a>
      </div>
    </div>
  </div>
}
